import { ActionTree } from "vuex";
import { RootState, StatePaymentSystems } from "@/store/types";
import { ACTION_TYPES, MUTATION_TYPES } from "@/lib/const";
import providers from "@/lib/providers";
import {
  InputPaymentSystemCreate,
  InputPaymentSystemUpdate,
} from "@teacherskaya/api-provider/dist/api/PaymentSystemsProvider";

const { STORE_DATA } = MUTATION_TYPES;

export const actions: ActionTree<StatePaymentSystems, RootState> = {
  async [ACTION_TYPES.GET_DATA](context) {
    const response = await providers.PaymentSystemsProvider.findAll();
    context.commit(STORE_DATA, response);
    return response;
  },
  async [ACTION_TYPES.ADD_DATA](context, { data }: { data: InputPaymentSystemCreate }) {
    const response = await providers.PaymentSystemsProvider.create({ data });
    context.commit(STORE_DATA, [response, ...context.state.systems]);
    return response;
  },
  async [ACTION_TYPES.SET_DATA](context, { data }: { data: InputPaymentSystemUpdate }) {
    const response = await providers.PaymentSystemsProvider.update({ data });
    context.commit(STORE_DATA, [...context.state.systems.map(item => (item.id === response.id ? response : item))]);
    return response;
  },
  async [ACTION_TYPES.DEL_DATA](context, { id }: { id: string }) {
    const response = await providers.PaymentSystemsProvider.delete({ id });
    context.commit(STORE_DATA, [...context.state.systems.filter(item => item.id !== id)]);
    return response;
  },
};
